import { createContext, useContext, type ReactNode } from 'react'

import { webAppState } from '@/appState'

const CurrentUserContext = createContext<string | null | undefined>(undefined)

export const ActorProvider = ({ currentUserId, children }: { currentUserId: string | null; children: ReactNode }) => (
    <CurrentUserContext.Provider value={currentUserId}>{children}</CurrentUserContext.Provider>
)

export const useActorCurrentUserId = () => {
    const currentUserId = useContext(CurrentUserContext)
    return currentUserId === undefined ? webAppState?.user?.userId : currentUserId
}
